var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 39.2197H33.25C35.1803 39.2197 36.75 37.65 36.75 35.7197V9.46973C36.75 7.53948 35.1803 5.96973 33.25 5.96973H29.75C29.75 5.5056 29.5656 5.06048 29.2374 4.73229C28.9093 4.4041 28.4641 4.21973 28 4.21973H14C13.5359 4.21973 13.0908 4.4041 12.7626 4.73229C12.4344 5.06048 12.25 5.5056 12.25 5.96973H8.75C6.81975 5.96973 5.25 7.53948 5.25 9.46973V35.7197C5.25 37.65 6.81975 39.2197 8.75 39.2197ZM8.75 9.46973H12.25V12.9697H29.75V9.46973H33.25V35.7197H8.75V9.46973Z",
    fill: "#006EC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 24.4952L16.1122 21.3574L13.6377 23.8319L19.2499 29.4442L28.3622 20.3319L25.8877 17.8574L19.2499 24.4952Z",
    fill: "#006EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures2);
export default __webpack_public_path__ + "static/media/features2.8da69c4238e5b648e76e866ee1fa041b.svg";
export { ForwardRef as ReactComponent };